import Vue from 'vue'
import './plugins'
import './components'
import './views'
import '../shared-components'
import '../shared-report'
import App from './App.vue'
import router from './router'
import store from '@/store'
import vuetify from '@/plugins/vuetify'
// import './registerServiceWorker'

Vue.config.productionTip = process.env.NODE_ENV === 'development'
Vue.config.devtools = true
new Vue({
  router,
  store,
  vuetify,
  render: h => h(App)
}).$mount('#app')
